<template>
  <div class="input-group password-input" :class="{ 'invalid-field': invalid || strengthText }">
    <label :for="name" class="required">Password</label>
    <input
      v-bind="$attrs"
      :id="name"
      v-model="password"
      type="password"
      :name="name"
      placeholder="Password"
      :class="{ 'invalid-field': invalid }"
      @input="p => $emit('input', p.target.value)"
      @keyup="calculateStrength"
    >
    <small v-if="strengthText && password" :class="strength" class="alert">{{ strengthText }}</small>
  </div>
</template>

<script>

export default {
  props: {
    name: { type: String, required: false, default: 'password' },
    invalid: { type: String, required: false, default: '' },
  },
  data: () => ({ password: '', strength: '', strengthText: '' }),
  methods: {
    calculateStrength() {
      // If the password length is less than or equal to 6
      if (this.password.length < 6) {
        this.strength = 'short';
        this.strengthText = 'Too short';
      }
      // If the password length is greater than 6 and contain any lowercase alphabet or any number or any special character
      if (
        this.password.length >= 6
        && (this.password.match(/[a-z]/)
          || this.password.match(/\d+/)
          || this.password.match(/.[!,@,#,$,%,^,&,*,?,_,~,-,(,)]/))
      ) {
        this.strength = 'weak';
        this.strengthText = 'Weak password';
      }
      // If the password length is greater than 6 and contain alphabet,number,special character respectively
      if (
        this.password.length >= 6
        && ((this.password.match(/[a-z]/) && this.password.match(/\d+/))
          || (this.password.match(/\d+/)
            && this.password.match(/.[!,@,#,$,%,^,&,*,?,_,~,-,(,)]/))
          || (this.password.match(/[a-z]/)
            && this.password.match(/.[!,@,#,$,%,^,&,*,?,_,~,-,(,)]/)))
      ) {
        this.strength = 'good';
        this.strengthText = 'Good password';
      }
      // If the password length is greater than 6 and must contain alphabets,numbers and special characters
      if (
        this.password.length >= 6
        && this.password.match(/[a-z]/)
        && this.password.match(/\d+/)
        && this.password.match(/.[!,@,#,$,%,^,&,*,?,_,~,-,(,)]/)
      ) {
        this.strength = 'strong';
        this.strengthText = 'Strong password';
      }

      if (this.strength) {
        this.$emit('strength', { strength: this.strength, text: this.strengthText });
      }
    },
  },
};
</script>

<style lang="scss">
.password-input {
  .alert {
    color: var(--main-red);
    position: absolute;
    margin-top: 6px;

    &.good {
      color: var(--accent);
    }

    &.strong {
      color: var(--main-green-shade-1);
    }
  }
}

.fa {
  .password-input {
    .alert:not(.good):not(.strong) {
      color: #E04A4A;
    }
  }
}
</style>
